import { TotalEventsGraph } from "./TotalEventsGraph";
export default TotalEventsGraph;
